import { useTranslation } from "react-i18next";
import { fallbackLanguage } from "./config";

function useLanguage() {
  const { i18n } = useTranslation();

  return i18n.language || fallbackLanguage;
}

export default useLanguage;
